var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMavueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 30V10H5.6V13.04C6.05333 12.24 6.77333 11.48 7.76 10.76C8.74667 10.04 10.0533 9.68 11.68 9.68C13.0133 9.68 14.24 10.04 15.36 10.76C16.5067 11.4533 17.4 12.44 18.04 13.72C18.3067 13.2667 18.72 12.72 19.28 12.08C19.8667 11.44 20.6267 10.88 21.56 10.4C22.4933 9.92 23.6133 9.68 24.92 9.68C26.2 9.68 27.4 10.0133 28.52 10.68C29.64 11.3467 30.5467 12.3067 31.24 13.56C31.96 14.7867 32.32 16.24 32.32 17.92V30H29.32V18C29.32 16.32 28.84 14.9733 27.88 13.96C26.9467 12.92 25.7733 12.4 24.36 12.4C22.8933 12.4 21.6267 12.8933 20.56 13.88C19.4933 14.8667 18.96 16.2533 18.96 18.04V30H15.96V18C15.96 16.32 15.48 14.9733 14.52 13.96C13.5867 12.92 12.4133 12.4 11 12.4C9.53333 12.4 8.26667 12.8933 7.2 13.88C6.13333 14.8667 5.6 16.2533 5.6 18.04V30H2.6Z",
    fill: "#101827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMavueIcon);
export default __webpack_public_path__ + "static/media/mavue-icon.5e1de3409e59b380431e63f814463992.svg";
export { ForwardRef as ReactComponent };